<template>
  <div class="container mx-auto px-4 py-8">
    <div class="mb-6">
      <a :href="toolsUrl" class="text-blue-500 hover:text-blue-700 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        <span>Back to Tools</span>
      </a>
    </div>

    <!-- Create Mode - Simple Form for Creating New Tools -->
    <NewToolForm 
      v-if="!isEditing" 
      :service="service"
      @tool-created="onToolCreated"
    />
    
    <!-- Edit Mode - Advanced Form for Editing Existing Tools -->
    <EditToolForm 
      v-if="tool.id" 
      :tool="tool"
      :service="service"
    />
  </div>
</template>

<script>
import RestService from "../services/RestService";
import NewToolForm from "./NewToolForm.vue";
import EditToolForm from "./EditToolForm.vue";

export default {
  name: 'ToolForm',
  components: {
    NewToolForm,
    EditToolForm
  },
  data() {
    return {
      model: nimbleai.model,
      service: new RestService('tools', '/'),
      tool: {
        id: null,
        slug: null,
        name: '',
        description: '',
        prompt_template: '',
        input_required: false,
        input_label: '',
        tone_required: false,
        prompt_required: true,
        default_prompt_details: '',
        template_type: '',
        category: '',
        category_color: '',
        icon: '',
        input_instructions: '',
        input_placeholder: '',
        input_example: '',
        output_description: '',
        ui_theme: '',
        tips: [],
        prompt_label: '',
        action_label: ''
      }
    }
  },
  computed: {
    isEditing() {
      return !!this.$route.params.id
    },
    toolsUrl() {
      if(this.isEditing) {
        return `/tools/${this.$route.params.id}`
      } else {
        return '/tools'
      }
    }
  },
  mounted() {
    console.log('ToolForm mounted')
    console.log('isEditing', this.isEditing)
    if (this.isEditing) {
      this.loadTool()
    }
  },
  methods: {
    loadTool() {
      console.log('loadTool')
      this.service.get(this.$route.params.id).then(tool => {
        console.log('tool', tool)
        this.tool = tool
      }).catch(error => {
        console.error('Error loading tool:', error)
      })
    },
    onToolCreated(tool) {
      console.log('onToolCreated', tool)
      this.tool = tool
    }
  }
}
</script>
